import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { BaseMaterialListControllerService, VendorInfoControllerService } from 'src/app/sdk/services';
import { AreabuildingControllerService } from 'src/app/sdk/services/areabuilding-controller.service';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
})
export class UploadFileComponent implements OnInit {
  @Input() dbName = "";
  @Input() isVisible: boolean = false;
  @Input() model: string;
  @Input() type: string;
  @Output() isVisibleChange = new EventEmitter<boolean>();
  @Output() isUpload = new EventEmitter<NzUploadFile[]>();
  confirmModal?: NzModalRef;
  uploading = false;
  fileList: NzUploadFile[] = [];
  constructor(
    private AreabuildingService: AreabuildingControllerService,
    private baseMaterialListControllerService: BaseMaterialListControllerService,
    private message: NzMessageService,
    private vendorInfoControllerService: VendorInfoControllerService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    // do something
  }


  beforeUpload = (file: NzUploadFile): boolean => {
    this.fileList = [];
    this.fileList = this.fileList.concat(file);
    return false;
  };

  async handleUpload() {
    switch (this.dbName) {
      case 'area_building':
        await this.AreabuildingService.uploadExcel({ body: this.fileList }).toPromise().then(e => {
          this.isUpload.emit();
          this.message.create('success', this.translateService.instant('Common.UploadComplete'));
          this.isVisibleChange.emit(false);
        }).catch(e => {
          this.message.create('error', `${this.translateService.instant('Common.UploadFailed')}`);
        });
        break;
      case 'base_material_list':
        this.baseMaterialListControllerService.uploadMaterialExcel({ body: this.fileList }).toPromise().then(e => {
          this.isUpload.emit();
          this.message.create('success', this.translateService.instant('Common.UploadComplete'));
          this.isVisibleChange.emit(false);
        }).catch(e => {
          this.message.create('error', `${this.translateService.instant('Common.UploadFailed')}`);
        });
        break;
      case 'vendor_info':
        this.vendorInfoControllerService.uploadVendorInfoExcel({ body: this.fileList }).toPromise().then(e => {
          this.isUpload.emit();
          this.message.create('success', this.translateService.instant('Common.UploadComplete'));
          this.isVisibleChange.emit(false);
        }).catch(e => {
          this.message.create('error', `${this.translateService.instant('Common.UploadFailed')}`);
        });
        break;
      default:
        break;
    }
  }
}
